import React from "react";
import { useLocation, useNavigate } from "react-router-dom";
import useDynamicColors from "../../../../../hooks/useDynamicColors";
import "./style.css";

export const AmericanNewOnboardingWelcome = () => {
  const colors = useDynamicColors();
  const location = useLocation();
  const navigate = useNavigate();

  const handleAddToWallet = () => {
    const currentParams = location.search;
    navigate(`/regional-landing-americannew-mobile${currentParams}`);
  };

  const handleDoItLater = () => {
    const currentParams = location.search;
    navigate(`/regional-landing-americannew-mobile${currentParams}`);
  };

  return (
    <div className="regional-welcome">
      <div className="regional-welcome-container">
        {/* Success Icon */}
        <div className="welcome-icon-container">
          <div className="welcome-icon-bg" style={{ backgroundColor: `${colors.secundario}40` }}>
            <div className="welcome-icon-inner" style={{ backgroundColor: `${colors.secundario}80` }}>
              <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M40 14L18 36L8 26"
                  stroke={colors.primario}
                  strokeWidth="4"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
            </div>
          </div>
          {/* Decorative dots around the icon */}
          <div className="decorative-dots">
            {[...Array(12)].map((_, i) => {
              const angle = (i * 30) * (Math.PI / 180);
              const radius = 80;
              const x = Math.cos(angle) * radius;
              const y = Math.sin(angle) * radius;
              return (
                <div
                  key={i}
                  className="decorative-dot"
                  style={{
                    left: `calc(50% + ${x}px)`,
                    top: `calc(50% + ${y}px)`,
                    backgroundColor: i % 2 === 0 ? colors.secundario : `${colors.secundario}60`,
                  }}
                />
              );
            })}
          </div>
        </div>

        {/* Title Section */}
        <div className="welcome-title-section">
          <h1 className="welcome-title" style={{ color: colors.primario }}>
            Your account is ready!
          </h1>
          <p className="welcome-subtitle">
            You can start using your account right away. Add your card to Apple Pay to make purchases in stores instantly.
          </p>
        </div>

        {/* Apple Wallet Button */}
        <div className="welcome-wallet-section">
          <button className="btn-apple-wallet" onClick={handleAddToWallet}>
            <img
              src="/img/apple-wallet-icon.svg"
              alt="Apple Wallet"
              className="wallet-icon"
              onError={(e) => {
                e.target.style.display = 'none';
              }}
            />
            <div className="wallet-text">
              <span className="wallet-label">Add to</span>
              <span className="wallet-name">Apple Wallet</span>
            </div>
          </button>
        </div>

        {/* Do It Later Link */}
        <div className="welcome-later-section">
          <button
            className="btn-do-later"
            style={{ color: colors.primario }}
            onClick={handleDoItLater}
          >
            I'll do it later
          </button>
        </div>
      </div>
    </div>
  );
};
